/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import {
    Create,
    Edit,
    required,
    SimpleForm,
    TextInput,
    useNotify,
    useRefresh,
    useRedirect,
    AutocompleteInput,
} from 'react-admin'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core'
import BackButton from '../../components/BackButton'
import Title from '../../components/Title/Title'
import '../style.css'
import CustomValidater from '../../components/Utility/Validater'
import CustomCheckbox from '../../components/CustomCheckbox/CustomCheckbox'

const styles = {
    field: {
        width: '100%',
    },
}

const useStyles = makeStyles(styles)

const documentTypes = [
    { label: 'Legal', value: 'legal' },
    { label: 'Degree', value: 'degree' },
    { label: 'Certificate', value: 'certificate' },
    { label: 'Formal', value: 'formal' },
]

const HRDocumentComponent = (props) => {
    const user = useSelector((state) => state.auth)
    const userData = {
        created_by: user.description,
        modified_by: user.description,
    }
    const { isEdit, title } = props
    const classes = useStyles()
    return (
        <SimpleForm
            validate={(values) => CustomValidater(values, props)}
            style={{ width: '100%' }}
            {...props}
            variant="outlined"
            warnWhenUnsavedChanges
            initialValues={userData}
        >
            <Title title={title} />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-evenly',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 0.6,
                    }}
                >
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 0.3 }}
                            variant="outlined"
                            label="Code"
                            source="code"
                            validate={[required()]}
                            disabled={isEdit}
                        />
                    </div>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 0.8 }}
                            variant="outlined"
                            label="Description"
                            source="description"
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 0.8 }}
                            variant="outlined"
                            label="Report Title"
                            source="report_title"
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <div
                            style={{
                                display: 'flex',
                                flex: 0.8,
                            }}
                        >
                            <AutocompleteInput
                                className={classes.field}
                                source="document_type"
                                label="Document Type"
                                optionText="label"
                                optionValue="value"
                                choices={documentTypes}
                                validate={required()}
                                variant="outlined"
                            />
                        </div>
                    </div>
                    <div className="container">
                        <CustomCheckbox
                            {...props}
                            source="is_expiry_option"
                            label="Expiry Option"
                        />
                    </div>
                </div>
                <div style={{ flex: 0.3 }}>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 0.49 }}
                            variant="outlined"
                            disabled
                            label="Created By"
                            source="created_by"
                            validate={required()}
                        />
                    </div>
                    <div className="container">
                        <TextInput
                            style={{ display: 'flex', flex: 0.49 }}
                            variant="outlined"
                            disabled
                            label="Modified By"
                            source="modified_by"
                            validate={required()}
                        />
                    </div>
                </div>
            </div>
        </SimpleForm>
    )
}

export default function CreateHRDocument(props) {
    const notify = useNotify()
    const refresh = useRefresh()
    const redirect = useRedirect()
    const { isEdit } = props
    const onSuccess = () => {
        notify(`Changes saved`)
        redirect('/PY_HRDocumentTAB')
        refresh()
    }
    if (isEdit)
        return (
            <>
                <BackButton path="/PY_HRDocumentTAB" />
                <Edit {...props} undoable={false}>
                    <HRDocumentComponent title="Edit HR Document" isEdit />
                </Edit>
            </>
        )
    return (
        <>
            <BackButton path="/PY_HRDocumentTAB" />
            <Create onSuccess={onSuccess} {...props}>
                <HRDocumentComponent
                    title="Create HR Document"
                    isEdit={false}
                />
            </Create>
        </>
    )
}

CreateHRDocument.propTypes = {
    isEdit: PropTypes.bool.isRequired,
}

HRDocumentComponent.propTypes = {
    isEdit: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
}
